// 같은 계열의 형제 사이트를 고른다.
//
// 국내(IWINV)는 antsnest.co.kr, 헤츠너는 antsnest.kr 로 나뉘어 있고 서로
// 백엔드가 다르다. 헤츠너에서 연 화면이 co.kr 을 부르면 안 된다 — 다른 쪽
// 시스템을 건드리는 셈이고, 로그인 팝업은 결과를 돌려줄 부모를 못 찾는다.
//
// talk 주소를 박아 두면 antsnest.kr 에서도 talk.antsnest.co.kr 이 열려,
// 팝업은 co.kr 로 메시지를 보내고 antsnest.kr 부모창은 아무것도 못 받는다.
// 실제로 그래서 "antsnest.kr 에서 로그인이 안 된다" 가 됐다.
export const FAMILIES = Object.freeze(['antsnest.kr', 'antsnest.co.kr']);

/** 이 host 가 속한 계열. 우리 도메인이 아니면 null. */
export function familyOf(hostname) {
  const host = String(hostname || '').toLowerCase();
  return FAMILIES.find((domain) => host === domain || host.endsWith('.' + domain)) || null;
}

/**
 * 지금 보고 있는 화면과 같은 계열의 형제 주소.
 *
 * 우리 도메인이 아니면(로컬 개발 등) co.kr 을 쓴다 — 운영 SSO 가 거기 있다.
 */
export function siblingOrigin(sub, location = window.location) {
  const family = familyOf(location.hostname) || 'antsnest.co.kr';
  return `https://${sub ? sub + '.' : ''}${family}`;
}

// antsnest.kr 에 실제로 있는 하위 도메인. 여기 없는 것을 계열 따라 바꾸면
// DNS 가 없어 링크가 죽는다 — app 과 malbok 이 그렇다.
const ON_HETZNER = Object.freeze([
  'talk', 'story', 'cast', 'store', 'play', 'estimate', 'meta', 'wbs',
  'edu', 'market', 'coin', 'music', 'file', 'town', 'archive', 'game', 'mdm',
]);

/**
 * 지금 보고 있는 것이 개발 환경인가.
 *
 * 개발은 두 가지 모습으로 온다.
 *   antsnest.kr 계열        헤츠너
 *   dev.* 로 시작하는 주소   dev.nodemaster.co.kr, dev.skyscribe.co.kr
 *
 * 운영과 생김새가 같아서, 개발에서 만진 것을 운영에서 한 줄 알고 넘어가기
 * 쉽다. 화면에 분명히 띄워야 한다.
 */
export function isDevEnvironment(location = window.location) {
  const host = String(location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return true;
  if (host.startsWith('dev.')) return true;
  return familyOf(host) === 'antsnest.kr';
}

/** 화면에 띄울 환경 이름. 운영이면 null — 아무것도 띄우지 않는다. */
export function environmentLabel(location = window.location) {
  const host = String(location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return '로컬';
  if (!isDevEnvironment(location)) return null;
  return '개발';
}

/**
 * 서비스 링크. 헤츠너에서 보면 헤츠너 것을, 국내에서 보면 국내 것을 연다.
 *
 * 헤츠너에 그 하위 도메인이 없으면 국내 주소를 그대로 쓴다. 억지로 바꾸면
 * 링크가 죽는다.
 */
export function serviceUrl(sub, location = window.location) {
  const family = familyOf(location.hostname) || 'antsnest.co.kr';
  if (family === 'antsnest.kr' && !ON_HETZNER.includes(sub)) {
    return `https://${sub}.antsnest.co.kr`;
  }
  return `https://${sub}.${family}`;
}

/** 팝업이 보낸 메시지를 받아도 되는 출처인가. */
export function isTrustedOrigin(origin) {
  let url;
  try {
    url = new URL(origin);
  } catch {
    return false;
  }
  if (url.protocol !== 'https:') return false;
  // 앞뒤 문자열 비교로 하면 antsnest.kr.evil.com 이 통과한다.
  return familyOf(url.hostname) !== null;
}
